module.exports = __webpack_public_path__ + "img/download.3f61822b.svg";